import ltLoginPopup from 'html/packages/lt-login-popup.html';
import App from 'app/app.js';
import 'app/directive/LtOrderSummaryStepTwoCtrl.js';

function LtLoginPopupDirective() {
  return {
    restrict: 'E',
    scope: {
      showLoginPopup: '=',
      close: '&'
    },
    template: ltLoginPopup,
    controller: 'LtLoginPopupCtrl',
    controllerAs: 'loginPopup'
  };
}

App.directive('ltLoginPopup', [LtLoginPopupDirective]);
